<ion-list style="flex: 1 1 auto;">
  <cdk-virtual-scroll-viewport
    [itemSize]="itemSize"
    [minBufferPx]="minBufferPx"
    [maxBufferPx]="maxBufferPx"
    class="ion-content-scroll-host"
    style="height: 100%"
  >
    <ion-progress-bar type="indeterminate" *ngIf="loading"></ion-progress-bar>
    <ion-item *ngIf="!items || items?.length === 0">
      <ion-label>
        <ion-text color="medium">
          <i style="font-size: 0.8rem">Geen items</i>
        </ion-text>
      </ion-label>
    </ion-item>
    <ng-content select="[slot=first-item]"></ng-content>
    <ion-item
      *ngIf="selectable"
      button
      mode="md"
      (click)="selectAll(items)"
      class="ion-text-center"
      color="secondary"
    >
      <ion-label> Selecteer alles ({{ items?.length || 0 }}) </ion-label>
    </ion-item>
    <ion-item
      *cdkVirtualFor="let item of items; trackBy: trackByFn"
      [button]="clickable"
      mode="md"
      (click)="clickable && itemClick(item)"
      class="transition"
      [class.selected]="clickable && isSelected(item)"
      [attr.data-mark-color]="listItems?.rowMarkColor ? listItems.rowMarkColor(item) : null"
      [routerLink]="
        clickable && listItems?.routerUrl
          ? getLink(item, listItems.routerUrl)
          : null
      "
      [routerDirection]="listItems?.routerDirection ?? 'forward'"
      [disabled]="isDisabled(item, listItems)"
    >
      <ion-text
        slot="start"
        color="secondary"
        (click)="check(item, $event)"
        *ngIf="selectable"
      >
        <fa-icon
          [icon]="['fal', 'check-square']"
          size="lg"
          *ngIf="isChecked(item)"
        ></fa-icon>
        <fa-icon
          [icon]="['fal', 'square']"
          size="lg"
          *ngIf="!isChecked(item)"
        ></fa-icon>
      </ion-text>
      <!-- use this -->
      <ion-avatar *ngIf="hasAvatar(item)" slot="start">
        <img
          [src]="
            item | displayAvatar : listItems | sanitizeImage : 'base64string'
          "
        />
      </ion-avatar>

      <ion-label>
        <ion-text
          *ngFor="let field of fields; first as first; index as i"
          [color]="
            field.color
              ? (item | displayColor : field.color)
              : first
              ? 'primary'
              : 'dark'
          "
        >
          <h5 *ngIf="first">
            <ng-container
              *ngTemplateOutlet="
                displayLabel;
                context: { item, field: fields[i] }
              "
            ></ng-container>
          </h5>

          <p *ngIf="!first" style="font-size: 0.8rem">
            <ng-container
              *ngTemplateOutlet="
                displayLabel;
                context: { item, field: fields[i] }
              "
            ></ng-container>
          </p>
        </ion-text>
      </ion-label>
      <ion-label slot="end" *ngIf="listItems?.endIcons?.length > 0">
        <ng-container *ngFor="let icon of listItems.endIcons">
          <ion-text color="medium">
            <fa-icon
              *ngIf="item | displayListIcon : icon as dispIcon"
              [icon]="['fal', dispIcon]"
              style="margin: 6px"
            ></fa-icon>
          </ion-text>
        </ng-container>
      </ion-label>
      <ion-label slot="end" *ngIf="listItems?.icons?.length > 0">
        <ng-container *ngFor="let icon of listItems.icons">
          <ion-text [color]="item | displayListIcon : icon?.color || 'medium'">
            <fa-icon
              *ngIf="item | displayListIcon : icon.icon as iconName"
              [icon]="['fal', iconName]"
              [size]="icon.size || 'lg'"
              style="margin: 6px"
              [fixedWidth]="true"
            ></fa-icon>
          </ion-text>
        </ng-container>
      </ion-label>
      <ion-label slot="end" *ngIf="isSelected(item)" color="primary">
        <fa-icon [icon]="['fal', 'chevron-right']"></fa-icon>
      </ion-label>
    </ion-item>
    <ion-infinite-scroll
      *ngIf="infiniteScroll"
      threshold="100px"
      (ionInfinite)="loadDataTrigger($event)"
      #infiniteScroll
    >
      <ion-infinite-scroll-content
        loadingSpinner="lines-sharp-small"
        loadingText="Gegevens laden..."
      >
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>

    <!-- Voeg een leeg blok toe voor extra ruimte zodat de buttons niet voor het laatste item staan-->
    <div style="height: 60px;"></div>
  </cdk-virtual-scroll-viewport>
</ion-list>

<ng-template #displayLabel let-item="item" let-field="field">
  <fa-icon
    *ngIf="field?.icon"
    [icon]="['fal', field?.icon]"
    [style.padding-right]="'.7rem'"
    [fixedWidth]="true"
  ></fa-icon>
  <ng-container [ngSwitch]="field.pipe">
    <span *ngSwitchCase="'date'">
      {{ item | displayProp : field | translocoDate : { dateStyle: 'medium' } }}
    </span>
    <span *ngSwitchDefault>{{ item | displayProp : field }}</span>
  </ng-container>
</ng-template>
